var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details-component"},[_c('div',{staticClass:"details-component__header"},[_c('h1',[_vm._v(_vm._s(_vm.$t('permits.permits'))+": "+_vm._s(_vm.productName))]),_vm._v(" "),_c('div',{staticClass:"details-component__header_right"})]),_vm._v(" "),_c('div',{staticClass:"details-component__content content"},[_c('v-client-table',{attrs:{"data":_vm.permits,"columns":_vm.columns,"options":_vm.options}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28cb10ac","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/products/Permits.vue
// module id = 1415
// module chunks = 65